import { type PropsWithChildren, type ReactNode } from "react";
import s from "./LayoutVariant1.module.scss";

export interface LayoutVariant1Props {
  layout: string;
  thumbContent?: ReactNode;
}

export default function LayoutVariant1(
  props: PropsWithChildren<LayoutVariant1Props>,
) {
  const { layout, thumbContent, children } = props;
  const bodyContent = <div className={s.contentWrapper}>{children}</div>;
  const [leftColumn, rightColumn] = layout.split(":");

  if (!thumbContent || !rightColumn) {
    return (
      <div className="row">
        <div className="col-12">{bodyContent}</div>
      </div>
    );
  }

  return (
    <div className="row gy-4">
      <div className={`col-12 col-lg-${leftColumn} ${s.thumbColumn}`}>
        {thumbContent}
      </div>
      <div className={`col-12 col-lg-${rightColumn}`}>{bodyContent}</div>
    </div>
  );
}
